module.exports = __webpack_public_path__ + "static/media/delete.24ef1327.svg";